import { createContext, useContext } from 'react';
import type { Access } from './access.repository';
import type { Permission } from '../permissions';
export const AccessContext = createContext<{
  refresh?: () => void;
  error?: string;
  data: Access | null;
  allows: (permission: Permission) => boolean;
}>({ data: null, allows: () => false });
export function useAccess() {
  return useContext(AccessContext);
}
